<template lang="pug">
  v-container(fluid grid-list-lg)
    Feedback(:location="location")
</template>

<script>
import Feedback from "../../Feedback/components/ListByStore";
import { mapGetters } from "vuex";
export default {
  components: {
    Feedback
  },
  computed: {
    ...mapGetters("location", ["location"]),
  },
}
</script>

<style scoped>
</style>